import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BusinessIcon from "@mui/icons-material/Business";
import { Autocomplete, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { t } from "i18next";
import { useEffect, useState } from "react";

export function CustomerRelatedCompaniesDropdown({ companies, onCompanySelect, onAddCompany, disabledAddCompany=false }) {
    const [selectedCompany, setSelectedCompany] = useState(
        companies && companies.length > 0 ? companies[0] : undefined,
    );

    useEffect(() => {
        if (companies && companies.length > 0) {
            setSelectedCompany(companies[0]);
        } else {
            setSelectedCompany(undefined);
        }
    }, [companies]);

    if (!companies || companies.length === 0) {
        return (
            <Grid container spacing={1} alignItems="center">
                <Grid item xs>
                    <TextField
                        fullWidth
                        size="small"
                        disabled
                        label={t("clients.ClientPassportDialog.noCompanies")}
                        value=""
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        size="small"
                        endIcon={<AddCircleOutlineIcon />}
                        onClick={onAddCompany}
                        disabled={disabledAddCompany}
                    >
                        {t("clients.ClientPassportDialog.add")}
                    </Button>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs>
                <Autocomplete
                    fullWidth
                    size="small"
                    options={companies}
                    disableClearable
                    value={selectedCompany}
                    onChange={(_, newValue) => {
                        setSelectedCompany(newValue ?? undefined);
                        if (newValue && onCompanySelect) {
                            onCompanySelect(newValue.company_id);
                        }
                    }}
                    getOptionLabel={(option) =>
                        `${option.company_name} (${t(`company.roles.${option.role}`) || option.role})`
                    }
                    renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key} {...optionProps}>
                                <Grid container spacing={2} sx={{ px: 1, width: "100%" }}>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                                display: "block",
                                            }}
                                        >
                                            {t("clients.ClientPassportDialog.companyName")}
                                        </Typography>
                                        <Typography variant="body2">
                                            {option.company_name || "-"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: "medium",
                                                color: grey[500],
                                                display: "block",
                                            }}
                                        >
                                            {t("clients.ClientPassportDialog.role")}
                                        </Typography>
                                        <Typography variant="body2">
                                            {t(`company.roles.${option.role}`) ||
                                                option.role ||
                                                "-"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("clients.ClientPassportDialog.companyRelations")}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <BusinessIcon sx={{ color: "action.active", mr: 1 }} />
                                ),
                            }}
                        />
                    )}
                />
            </Grid>
            <Grid item>
                <IconButton color="primary" size="small" onClick={onAddCompany}>
                    <AddCircleOutlineIcon />
                </IconButton>
            </Grid>
        </Grid>
    );
}
